import constants from '@/libs/constant/constants'
import {isEmpty, filter, find} from 'lodash'
import countryCode from '@/libs/constant/countrycode'
import locationFormMixin from '@/mixins/locationFormMixin';

export default {
    name: 'LocationForm',
    mixins: [locationFormMixin],
    data() {
        return {
            isEmpty,
            user: {
                line1: '',
                line2: '',
                city: '',
                country_code: '',
                postal_code: '',
                country_name: ''
            },
            contact_detail: {
                phone: '',
                fax: '',
                email: ''
            },
            validatePostalCode: this.validatePostalCodeFunction
        }
    },
    watch: {
        userData (value) {
            this.user = {
                line1: value.line1 || '',
                line2: value.line2 || '',
                city: value.city || '',
                postal_code: value.postal_code || '',
                country_code: value.country_code || '',
                country_name: value.country_name || ''
            }
            this.contact_detail = {
                phone: value.contact_detail && value.contact_detail.phone || '',
                fax: value.contact_detail && value.contact_detail.fax || '',
                email: value.contact_detail && value.contact_detail.email || ''
            }
            // this.findState()
        }
    },
    props:{
        module:{
            type: String
        },
        userData:{
            type: Object,
            default: ()=>{}
        },
        isAdmin: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: ()=> false
        },
        editUserLocation: {
            type: Function,
            default: ()=>{}
        }
    },
    methods: {
        getLocationHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Author Location'
                case constants.PUBLISHER.key:
                    return 'Publisher Location'
                case constants.PUBLICATION.key:
                    return 'Publication Location'
                case 'USER':
                    return 'User Location'    
            }
        },
        getLocationSubHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Please provide the main location of the Author'
                case constants.PUBLISHER.key:
                    return 'Please provide the main location of the Publisher'
                case constants.PUBLICATION.key:
                    return 'Please provide the main location of the Publication'
                case 'USER':
                    return 'User Address'    
            }
        },
        validateField (rule, value, callback) {
            if (!isEmpty(value) && !value.match(/^[0-9a-z-A-Z]+$/)) callback(new Error('Invalid characters'))
            else callback() 
        },
        submitForm (formName) {
            this.$refs[formName].validate(valid => {
                if (!valid) return
                const location = this.user;
                if (this.isShowStateField && this.selectedState && !isEmpty(this.selectedState)) {
                    location.state = this.selectedState._id
                }
                this.editUserLocation(this.user, this.contact_detail)
            })
        },
        disabledButton () {
            if (this.userData.line1 !== this.user.line1 || this.userData.line2 !== this.user.line2 || this.userData.city !== this.user.city || this.userData.postal_code !== this.user.postal_code || this.userData.country_code !== this.user.country_code) {
                return false
            }
            return true
        },
        disabledPublisherLocationForm () {
            if (this.userData.line1 !== this.user.line1 || this.userData.line2 !== this.user.line2 || this.userData.city !== this.user.city || this.userData.postal_code !== this.user.postal_code || this.userData.country_code !== this.user.country_code || this.userData.contact_detail.phone !== this.contact_detail.phone || this.userData.contact_detail.email !== this.contact_detail.email || this.userData.contact_detail.fax !== this.contact_detail.fax) return false
            return true
        },
        validateEmail (rule, value, callback) {
            let pattern = /\S+@\S+\.\S+/;
            if (!isEmpty(value) && !pattern.test(value)) callback(new Error('Invalid email'))
            else callback() 
        },
        handleInputConfirm (item) {
            this.user.country_code = item.country_code || ''
            this.user.country_name = item.country_name || ''
            this.fetchStateList(item)
        },
        querySearch: async function (search, cb) {
            if (search === '' && search === null && search.length < 2) return 
            let results = []
            if (!isEmpty(this.countries)) {
                 results = await filter(this.countries, (c) => {
                   return c.country_name.toLowerCase().includes(search.toLowerCase())
                })
            }
            cb(results)
        },
        getDisabledFormClass () {
            if (this.module === 'PUBLISHER') {
                return this.disabledPublisherLocationForm()
            }
            return this.disabledButton()
        },
        /**
         * validate postal code
         * @param {*} rule 
         * @param {*} value 
         * @param {*} callback 
         */
         validatePostalCodeFunction (rule, value, callback) {
            let regex = ''
            if (this.user.country_code && this.user.country_code !== '') {
                // find the address code and regex
                const code = find(countryCode, {abbrev: this.user.country_code})
                regex = (code && code.postal) || ''
            }
            // validate postal code on basis of regex
            if (regex !== '' && value && value !== '' && !new RegExp(regex).test(value)) callback(new Error('Invalid Postal code'))
            else callback()
        },

        /**
         * find state
         */
         async findState () {
            if ((this.user && this.user.country_code) || (this.userData.address && this.userData.address.country_code)) {
                const findCountry = find(this.countries, {country_code: ((this.userData.country_code) || (this.userData.address.country_code))});
                if (findCountry) {
                    await this.fetchStateList(findCountry);
                    if ((this.userData.address && this.userData.address.state)) {
                        const findState = find(this.states, {_id: ((this.userData.address.state))});
                        if (findState) {
                            this.selectedState = findState
                            this.searchState = findState.state_code
                        }
                    }
                }
            }
        },
    }
}